import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { ORGANIZATION_ENTITY_PRIORITY_CONFIG } from "../Tabs/PriorityFilter/organizationEntityPriority.constant";

interface Props {
    filters: FiltersTypes;
}

export const PriorityFilterLabel: React.FC<Props> = ({ filters }) => {
    const { priority } = filters;

    if (!priority || priority.length === 0) {
        return null;
    }

    if (priority.length === 1) {
        return (
            <span>
                {ORGANIZATION_ENTITY_PRIORITY_CONFIG[priority[0]].label}
            </span>
        );
    }

    return <span>{priority.length} priorities</span>;
};
